export default __webpack_public_path__ + "static/media/class3.6c3dd023.png";